/* eslint-disable */
// Disabling eslint for this file because it's a utility function and there are a bunch of React hook errors
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch } from "../app/hooks";
import { setCurrentModal } from "../thunks/setCurrentModal";
import { MESSAGE_MODAL_ID } from "../modals/MessageModal";
import { useTranslation } from "react-i18next";

export function alertUnsavedChanges(message: string, when: boolean, callback: () => void, avoidUnsavedChanges: boolean) {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
  
    useEffect(() => {
      let unblock: (() => void) | undefined;
  
      if (when && !avoidUnsavedChanges) {
        // Create a prompt message handler
        unblock = history.block((tx: { pathname: string; search: string; hash: string; state: any }) => {
          const state = window.redux_store.getState();
          const userLogout = state.userLogout;

          // If the user wants to go to the home page, allow it. 
          // Log out is the same so therefore we try to sync that
          // This is to prevent the user from being logged out.
          if (tx.pathname === '/' && userLogout) {
            // If we don't return true, the app crashes when the user tries to log out
            return true;
          }

          // Show modal and prevent navigation until user confirms
          dispatch(
            setCurrentModal({
              modalId: MESSAGE_MODAL_ID,
              params: {
                title: message,
                action: () => {
                    callback();
                    dispatch(setCurrentModal(null));
                    // return true to retry the navigation
                },
                buttonText: t('button.save'),
                onClose: () => {
                    dispatch(setCurrentModal(null));
                }
              },
              clearReturnModalDetails: true,
            }),
          );
          
          return false; // Block navigation until explicitly retried
        });
      }
  
      // Cleanup function to remove the history block
      return () => {
        if (unblock) {
          unblock();
        }
      };
    }, [when, avoidUnsavedChanges, history]);
  }